import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
export const isLiveLaunchDocument = (value: Record<string, unknown> | undefined): boolean =>
  value?.schemaVersion === 1 &&
  value.phase === "live" &&
  value.hasPublicRaces === true;

export const publicSiteService = {
  subscribeLaunch(onValue: (live: boolean) => void, onError: () => void) {
    return onSnapshot(doc(db, "publicSiteState", "launch"),
      snapshot => onValue(snapshot.exists() && isLiveLaunchDocument(snapshot.data())), onError);
  },
};
